/**
 * BLOC CARTE
 * Arrivée en scrub : la photo de gauche puis celle de droite se révèlent depuis
 * leur bord bas, puis la carte centrale remonte.
 *
 * Les photos sont révélées au clip-path plutôt que déplacées : pas de débordement
 * à contenir, et le zoom interne de l'image reste clippé par le cadre.
 */
jQuery(document).ready(function ($) {

    const DEP_GAUCHE = 0        // départs dans la timeline normalisée
    const DEP_DROITE = .25
    const DEP_CARTE = .45

    const DUREE_PHOTO = .45     // durée de révélation d'une photo
    const DUREE_CARTE = .45
    const MONTEE_CARTE = .65    // remontée de la carte, en fraction de la hauteur d'écran

    /**
     * Sous 960px la carte n'est plus dans une colonne à elle : elle est empilée
     * au-dessus des deux photos. Une amplitude de 65vh la ferait passer par
     * dessus la photo du dessous pendant tout le scrub.
     */
    const MONTEE_CARTE_EMPILEE = .15
    const BASCULE_EMPILEE = 960
    const ZOOM = 1.08           // dézoom de la photo pendant sa révélation
    const LISSAGE = .8          // secondes de rattrapage du scroll

    // animations réduites : tout reste visible, aucun tween créé
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
        return

    $(".bloc_carte").each(function () {
        const bloc = this
        const gauche = bloc.querySelector(".visuel_gauche")
        const droite = bloc.querySelector(".visuel_droite")
        const carte = bloc.querySelector(".carte")

        if (!gauche && !droite && !carte)
            return

        const tl = gsap.timeline({
            defaults: { ease: "power2.out", force3D: true },
            scrollTrigger: {
                trigger: bloc,
                start: "top bottom",
                end: "center center",
                scrub: LISSAGE,
                invalidateOnRefresh: true
            }
        })

        // 1 — photo de gauche : le cadre grandit vers le haut depuis son bord bas
        if (gauche) {
            tl.fromTo(gauche,
                { clipPath: "inset(100% 0% 0% 0%)" },
                { clipPath: "inset(0% 0% 0% 0%)", duration: DUREE_PHOTO },
                DEP_GAUCHE)

            tl.fromTo(gauche.querySelectorAll("img"),
                { scale: ZOOM },
                { scale: 1, duration: DUREE_PHOTO },
                DEP_GAUCHE)
        }

        // 2 — photo de droite : même sens, le cadre grandit vers le haut
        if (droite) {
            tl.fromTo(droite,
                { clipPath: "inset(100% 0% 0% 0%)" },
                { clipPath: "inset(0% 0% 0% 0%)", duration: DUREE_PHOTO },
                DEP_DROITE)

            tl.fromTo(droite.querySelectorAll("img"),
                { scale: ZOOM },
                { scale: 1, duration: DUREE_PHOTO },
                DEP_DROITE)
        }

        // 3 — la carte centrale : simple remontée, ni clip ni fondu.
        // Amplitude relative à la hauteur d'écran, recalculée à chaque resize
        // grâce à invalidateOnRefresh.
        if (carte) {
            tl.fromTo(carte,
                {
                    y: function () {
                        const amplitude = window.innerWidth < BASCULE_EMPILEE
                            ? MONTEE_CARTE_EMPILEE
                            : MONTEE_CARTE

                        return window.innerHeight * amplitude
                    }
                },
                { y: 0, duration: DUREE_CARTE },
                DEP_CARTE)
        }
    })

})
